import React from 'react';
import { Link } from 'react-router-dom';
import TextAnimation from './animations/TextAnimation';

const HeaderMenu = () => {
  return (
    <>
    <TextAnimation clssName={'.header__menu_list'} distance={'20px'} easeTime={'30'} />


    <header className={"header__menu"}>

        <h1 className={"userName header__menu_list"}>
          <Link to="/">
            ( TKY<span className={"copylightText"}>™︎</span>  — 09 )
          </Link>
        </h1>

        {/* <ul>
          <li className={"header__menu_list"}><Link to="/">Home</Link></li>
          <li className={"header__menu_list"}><Link to="/works">Works</Link></li>
          <li className={"header__menu_list"}><Link to="/gallery">Gallery</Link></li>
          <li className={"header__menu_list"}><a href="/">Instagram</a></li>
        </ul> */}
    </header>
    </>
  );
};


export default HeaderMenu;